<template>
  <div v-if="!loading">
    <hilo-button styleType="back" />
    <h1>{{ isEditMode ? `Edit ${addEditType}` : `Add ${addEditType}` }}</h1>
    <form @submit.prevent="submitForm" class="form-container">
      <slot :formData="formData"></slot>
      <div class="form-group full-width">
        <hilo-button type="submit" styleType="submit" label="Save" />
      </div>
    </form>
  </div>
</template>

<script>
import HiloButton from "../../../../components/HiloComponents/HiloButton.vue";

export default {
  components: { HiloButton },
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    addEditType: {
      type: String,
      required: true,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
    submitAction: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      formData: { ...this.initialData },
    };
  },
  async created() {
    this.loading = false;
  },
  methods: {
    async submitForm() {
      try {
        await this.submitAction(this.formData);
        this.$router.back();
      } catch (error) {}
    },
  },
};
</script>

<style scoped>
.form-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.form-group.full-width {
  grid-column: span 4;
}
</style>
